import { PublicApiClient } from '@tf/api';
import { Center, Image, Loader } from '@tf/ui';
import type React from 'react';
import { useEffect, useState } from 'react';

interface Props {
	objectId: string | null;
}

export const ImageDisplay: React.FC<Props> = ({ objectId }) => {
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	useEffect(() => {
		if (!objectId) {
			return;
		}

		const downloadImage = async () => {
			const res = await PublicApiClient.getInstance().request({
				path: `/v1/data/general_graph/object/${encodeURIComponent(objectId)}/download`,
			});
			const blob = await res.blob();
			setImageUrl(URL.createObjectURL(blob));
		};

		downloadImage();
	}, [objectId]);

	return (
		<Center mah="64rem" m="1rem">
			{!imageUrl ? <Loader size={30} /> : <Image src={imageUrl} alt="image" mah="64rem" />}
		</Center>
	);
};
